import { clearMaximo } from "../../../../services";

async function clearAllFromMaximo(
  clearDb,
  toclearMaximo,
  checkVersions,
  confirm = false
) {
  return await clearMaximo(clearDb, toclearMaximo, checkVersions, confirm);
}

export default clearAllFromMaximo;
